import { useCopyAPIKeyIntegration } from "../CopyAPIKeyModal/useCopyAPIKeyIntegration";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import LevvyLogo from "./LevvyLogo";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LevvyCard() {
  const {
    showCopyAPIKeyModal
  } = useCopyAPIKeyIntegration('levvy');
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "levvy-card",
    icon: /*#__PURE__*/_jsx(LevvyLogo, {}),
    title: "Levvy",
    subTitle: "Integrate with Levvy to automate client setup and workflow creation",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: showCopyAPIKeyModal,
      "data-testid": "levvy-card-connect",
      children: "Connect"
    })
  });
}